import { Button } from '@mantine/core';
import { Component, ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

type State = {
  hasError: boolean;
  error: Error | null;
};

export class ChunkErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      const isChunkError =
        this.state.error?.message?.includes('Loading chunk') ||
        this.state.error?.message?.includes('Failed to fetch');

      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '50vh',
            padding: '32px',
            textAlign: 'center',
          }}
        >
          <h2
            style={{
              color: '#0f172a',
              marginBottom: '8px',
              fontSize: '1.5rem',
              fontWeight: 600,
            }}
          >
            {isChunkError ? 'Connection issue' : 'Something went wrong'}
          </h2>
          <p style={{ color: '#64748b', marginBottom: '24px' }}>
            {isChunkError
              ? 'Please check your internet connection and try again.'
              : 'An unexpected error occurred.'}
          </p>
          <Button onClick={this.handleRetry}>Retry</Button>
        </div>
      );
    }

    return this.props.children;
  }
}
